module.exports = __webpack_public_path__ + "img/12.45f45e46.jpg";